<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>สาขา/เรื่องที่เชียวชาญ</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-btn slot="activator" color="primary" dark class="mb-2" v-if="hasAccess(allowedRoles)">เพิ่ม</v-btn>
        <v-card>
          <v-card-title>
            <span class="title">{{ formTitle }}</span>
            <v-spacer></v-spacer>
            <v-btn flat icon color="grey" @click="close">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 md12>
                  <v-textarea v-model="editedItem.name" label="ชื่อ"></v-textarea>
                </v-flex>
                <v-flex xs12 md12>
                  <v-textarea v-model="editedItem.remark" label="หมายเหตุ"></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="grey white--text" @click="close">ยกเลิก</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="green white--text" @click="save">บันทึก</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="personData.expertises"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-left">{{ props.item.remark }}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
            v-if="hasAccess(allowedRoles)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="deleteItem(props.item)"
            v-if="hasAccess(allowedRoles)"
          >
            delete
          </v-icon>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { hasAccessMixin } from '@/mixins/hasAccessMixin'
import swal from 'sweetalert2'

export default {
  mixins: [ hasAccessMixin ],
  props: [ 'personId' ],
  data: () => ({
    allowedRoles: ['ROLE_ADMIN', 'ROLE_SERVICE'],
    dialog: false,
    headers: [
      { text: 'ชื่อ', value: 'name' },
      { text: 'หมายเหตุ', value: 'remark' },
      { text: 'Actions', value: 'name', align: 'center', sortable: false }
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {

    },
    defaultItem: {
      
    },
    rules: {
      required: (value) => !!value || 'ไม่สามารถเป็นค่าว่าง'
    },
    valid: false
  }),

  computed: {
    ...mapGetters({
      personData: 'person/personData'
    }),
    formTitle () {
      return this.editedIndex === -1 ? 'เพิ่มรายการ' : 'แก้ไขรายการ'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    
  },

  methods: {
    editItem (item) {
      this.editedIndex = this.personData.expertises.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.personData.expertises.indexOf(item)
      swal({
        title: 'คุณแน่ใจ?',
        text: "คุณจะไม่สามารถเรียกคืนข้อมูลได้อีก!",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่, ฉันต้องการลบข้อมูลนี้!'
      }).then((result) => {
        if (result.value) {
          const dispatch = 'person/deleteItem'
          item.dispatch = 'expertises'
          this.$store.dispatch(dispatch, item)
            .then((response) => {
              setTimeout( ()=> this.$store.dispatch('person/fetchPerson', this.personId), 500)
              this.close()
            }).catch((error)=>{
              console.log('initialize', error)
              swal('เกิดข้อผิดพลาด!', error.message, 'error')
            })
          swal(
            'ลบรายการ!',
            'คุณได้ทำการลบรายการเรียบร้อยแล้ว',
            'success'
          )
        }
      })
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      const dispatch =  this.editedIndex === -1 ? 'person/createItem' : 'person/updateItem'
      this.editedItem.person = this.personId
      this.editedItem.dispatch = 'expertises'
      this.$store.dispatch(dispatch, this.editedItem)
        .then((response) => {
          swal({
              title: 'Success!',
              type: 'success'
            }).then(response => {
              setTimeout( ()=> this.$store.dispatch('person/fetchPerson', this.personId), 500)
              this.close()
            })
        }).catch((error)=>{
          console.log('error', error)
          swal('Error!', error.message, 'error')
        })
      this.close()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/person/shows/expertise/index.vue